import { Database, CloudRain, Filter, ClipboardCheck } from "lucide-react";
import { THC } from "@/lib/tankHealthCheck";

const CARDS = [
  [Database, "TANK SEDIMENT CHECK",
    "We look for visible build-up, debris and overall tank condition."],
  [CloudRain, "CATCHMENT & FIRST FLUSH",
    "We assess your roof, gutters and first-flush system for obvious contamination pathways."],
  [Filter, "FILTRATION & UV",
    "We check your existing filtration and UV disinfection setup."],
  [ClipboardCheck, "PRACTICAL NEXT STEPS",
    "You’ll get clear advice on recommended next steps."],
];

export function WhatWeCheck() {
  return (
    <section id="what-we-check" className="mx-auto max-w-[1440px] px-[18px] md:px-7 xl:px-10 pt-9 md:pt-14"
      data-testid="thc-what-we-check">
      <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-4">
        <h2 className="font-extrabold uppercase leading-[1.05] text-[29px] md:text-[36px] xl:text-[41px]"
          style={{ color: THC.navy, fontFamily: "'Outfit',system-ui,sans-serif" }}>
          WHAT WE CHECK
        </h2>
        <p className="text-[16px] xl:text-[17px]" style={{ color: THC.blue }}>
          A practical on-site assessment of your tank-water system.
        </p>
      </div>
      <div className="mt-5 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[18px] xl:gap-5">
        {CARDS.map(([Icon, title, copy]) => (
          <article key={title} data-testid={`thc-check-card-${title.split(" ")[0].toLowerCase()}`}
            className="bg-white rounded-[14px] border p-[18px] md:p-[22px] flex md:flex-col items-start md:items-center gap-4 md:gap-3 md:text-center min-h-[126px] md:min-h-[150px] transition-transform hover:-translate-y-1"
            style={{ borderColor: THC.border, boxShadow: THC.shadow }}>
            <span className="shrink-0 w-[54px] h-[54px] xl:w-[58px] xl:h-[58px] rounded-full grid place-items-center"
              style={{ backgroundColor: THC.blue }}>
              <Icon className="w-7 h-7 text-white" aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-extrabold text-[19px] xl:text-[22px] leading-tight" style={{ color: THC.navy }}>{title}</h3>
              <p className="mt-1.5 text-[15.5px] xl:text-[16px] leading-[1.45]" style={{ color: THC.body }}>{copy}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
